import { render, staticRenderFns } from "./reportPersonnelFollow.vue?vue&type=template&id=8ce380d4&scoped=true&"
import script from "./reportPersonnelFollow.vue?vue&type=script&lang=js&"
export * from "./reportPersonnelFollow.vue?vue&type=script&lang=js&"
import style0 from "./reportPersonnelFollow.vue?vue&type=style&index=0&id=8ce380d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce380d4",
  null
  
)

export default component.exports